import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  text-align: right;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: auto;\n  padding-bottom: ", ";\n  padding-top: ", ";\n  resize: ", ";\n\n  &::placeholder {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { placeholder } from '@scp/ui-shared/theme/typography-styles';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { FieldWrapper } from './FieldWrapper';
import { FieldBase } from './base';
import { Label } from './Label';
import { Subtext } from '@scp/ui-shared/components/typography';
import { baselineToRem } from '@scp/ui-shared/theme/utils';
var E2E_TITLE_SUFFIX = '-field';
var E2E_TEXTAREA_SUFFIX = '-field-textarea';
var AreaInput = styled(FieldBase.withComponent('textarea'))(_templateObject(), function (props) {
  return props.showCount ? baselineToRem(8) : baselineToRem(3);
}, baselineToRem(3), function (props) {
  return props.resize ? 'vertical' : 'none';
}, placeholder);
var Count = styled(Subtext).attrs({
  noMargin: true,
  secondary: true
})(_templateObject2());
var LabelWrapper = styled.div(_templateObject3());
/**
 * @example ./__docs__/Textarea.md
 */

export var TextArea = function TextArea(_a) {
  var ariaDescribedBy = _a.ariaDescribedBy,
      id = _a.id,
      _a$label = _a.label,
      label = _a$label === void 0 ? '' : _a$label,
      _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      _a$errorText = _a.errorText,
      errorText = _a$errorText === void 0 ? '' : _a$errorText,
      _a$hiddenLabel = _a.hiddenLabel,
      hiddenLabel = _a$hiddenLabel === void 0 ? false : _a$hiddenLabel,
      _a$hideError = _a.hideError,
      hideError = _a$hideError === void 0 ? false : _a$hideError,
      _a$value = _a.value,
      value = _a$value === void 0 ? '' : _a$value,
      _a$showCount = _a.showCount,
      showCount = _a$showCount === void 0 ? false : _a$showCount,
      innerRef = _a.innerRef,
      maxLength = _a.maxLength,
      isOptional = _a.isOptional,
      _a$resize = _a.resize,
      resize = _a$resize === void 0 ? false : _a$resize,
      hint = _a.hint,
      afterLabelComponent = _a.afterLabelComponent,
      otherProps = __rest(_a, ["ariaDescribedBy", "id", "label", "disabled", "errorText", "hiddenLabel", "hideError", "value", "showCount", "innerRef", "maxLength", "isOptional", "resize", "hint", "afterLabelComponent"]);

  var dataE2eTitleLabel = getE2eLabel(id, E2E_TITLE_SUFFIX);
  var dataE2eTextareaLabel = getE2eLabel(id, E2E_TEXTAREA_SUFFIX);
  return React.createElement(FieldWrapper, {
    id: id,
    errorText: errorText,
    hideError: hideError,
    hint: hint
  }, React.createElement(LabelWrapper, null, React.createElement(Label, {
    disabled: disabled,
    visuallyHidden: hiddenLabel,
    htmlFor: id,
    isOptional: isOptional,
    dataE2e: dataE2eTitleLabel
  }, label), afterLabelComponent), React.createElement(AreaInput, Object.assign({
    "aria-describedby": ariaDescribedBy,
    id: id,
    isInvalid: !!errorText,
    disabled: disabled,
    ref: innerRef,
    maxLength: maxLength,
    showCount: showCount,
    resize: resize
  }, otherProps, {
    value: value || '',
    "data-e2e": dataE2eTextareaLabel
  })), showCount && React.createElement(Count, null, value.length, maxLength ? " / ".concat(maxLength) : null));
};